import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useUpdateCustomSectionDefinition = function () {
    return useApiCall(function (signal, payload) {
        return api.customSections.apiCustomFieldSectionIdPut(payload.id, payload, { signal: signal });
    }, null, true, [], { success: 'Custom section updated.' });
};
